exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-popover[data-v-30639050]{display:inline-block}.trigger[data-v-30639050]{outline:none}.tray-menu-item-popover[data-v-30639050]{color:#fff}.tray-menu-item-description[data-v-30639050]{color:#dcdcdc;word-break:break-word;word-wrap:break-word}.tray-menu-button-wrapper[data-v-30639050]{margin:5px 0 0;display:inline-block;text-align:center;width:100%}", ""]);

// exports
